// https://www.kunkalabs.com/mixitup/docs/get-started/
import mixitup from 'mixitup';

$(document).ready(function () {
    var initialFilter = 'all';
    var hash = window.location.hash.replace(/^#/g, '');
    if (hash) {
        initialFilter = '.' + hash;
    }

    if ($('.mixit--filter').length) {
        var mixer = mixitup('.mixit--filter', {
            animation: {
                animateResizeTargets: true,
                duration: 600,
                nudge: true,
                reverseOut: true,
                effects: 'fade scale(0.01) translateZ(-100px)',
            },
            selectors: {
                control: '.mixitup-control',
            },
            // load: {
            //     filter: initialFilter,
            // },

            callbacks: {
                onMixClick: function(state, originalEvent) {
                    window.dispatchEvent(new Event('resize'));
                    if (originalEvent.target.getAttribute('data-filter') == 'all') {
                        $('.referenzen--grid ').addClass('grid--big');
                    } else {
                        $('.referenzen--grid ').removeClass('grid--big');
                    }
                    window.dispatchEvent(new Event('resize'));
               },

                onMixEnd: function (state) {
                    $('.popup--content').fadeOut();
                    $('span[popupbutton]').removeClass('active');
                },
            },
        });
    }
});
